import * as React from 'react';
import {LazyMotion as BaseLazyMotion} from 'framer-motion';
import type {LazyProps} from 'framer-motion';

/**
 * Used to reduce bundle size. `LazyMotion` can then be used to either
 * synchronously or asynchronously load animation and gesture support.
 *
 * ```jsx
 * // Synchronous loading
 * import { LazyMotion, domAnimations } from "@sail/motion"
 *
 * function App(props) {
 *   return (
 *     <LazyMotion features={domAnimations}>
 *       {props.children}
 *     </LazyMotion>
 *   )
 * }
 *
 * // Asynchronous loading
 * import { LazyMotion } from "@sail/motion"
 *
 * function App(props) {
 *   return (
 *     <LazyMotion features={() => import('./path/to/domAnimations')}>
 *       {props.children}
 *     </LazyMotion>
 *   )
 * }
 * ```
 */
export function LazyMotion({
  // Default LazyMotion to use strict mode, which ensures that code-splitting
  // benefits are maintained. For more information, see:
  //   https://www.framer.com/motion/lazy-motion/###strict
  strict = true,
  ...props
}: LazyProps) {
  return <BaseLazyMotion strict={strict} {...props} />;
}
